<template>

<div class="form-group form-group-sm">
	<label class="control-label col-sm-4">{{label}}</label>
	<div class="col-sm-8">
		<select v-model="aggregation" class="form-control">
		  <option v-for="option in accepted" v-bind:value="option.value">
		    {{ option.text }}
		  </option>
		</select>
	</div>
</div>

</template>
<script type="text/javascript">
	export default {
		data(){
			return {
				aggregation: this.value,
				accepted: [
					{value: '', text: 'None'},
					{value: 'avg', text: 'Average'},
					{value: 'min', text: 'Min'},
					{value: 'max', text: 'Max'},
					{value: 'sum', text: 'Sum'},
				]
			}
		},
		props: ['value', 'label'],
		watch:{
			aggregation(value){
				this.$emit('input', value)
			}
		}
	}
</script>
